import { callJsonApi } from './callApi';

/**
 *
 * @param apiServerUrl: URL of the OCDB API
 */
export function getFidraddbFiles(apiServerUrl: string, namePart = '__ALL__'): Promise<string[]> {
    return callJsonApi<string[]>(`${apiServerUrl}/store/FidRadDB/list/files/${encodeURIComponent(namePart)}`);
  }